var render = function render(){var _vm=this,_c=_vm._self._c;return _c('queryMetaConfig',{ref:"formDesign",attrs:{"dbTables":_vm.dbTableData}})
}
var staticRenderFns = []

export { render, staticRenderFns }